var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map", attrs: { id: "chart-map" } },
    [
      _c("layer-switcher-component", {
        staticClass: "map-lsw",
        attrs: {
          activeOverlaySelector: false,
          activeBaseLayer: _vm.checkedBaseLayer,
          onBaseLayerChange: _vm.changeBaseLayer,
          baseLayers: _vm.baseLayers,
          coherenceIntervals: _vm.$conf.map.layers.coherenceIntervals,
        },
      }),
      _vm._v(" "),
      _vm.dates.indexOf(_vm.date) > 0
        ? _c(
            "a",
            {
              staticClass: "rotate prev",
              attrs: { href: "#" },
              on: { click: (e) => _vm.prevDate(e) },
            },
            [
              _c("b-icon", {
                attrs: {
                  icon: "chevron-left-circle",
                  type: "is-black",
                  size: "is-large",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dates.indexOf(_vm.date) < _vm.dates.length - 1
        ? _c(
            "a",
            {
              staticClass: "rotate next",
              attrs: { href: "#" },
              on: { click: (e) => _vm.nextDate(e) },
            },
            [
              _c("b-icon", {
                attrs: {
                  icon: "chevron-right-circle",
                  type: "is-black",
                  size: "is-large",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "has-background-black-ter",
          attrs: { id: "chart-map-statusbar" },
        },
        [
          _vm.$conf.chart.copyrights.length
            ? _c("span", {
                staticClass: "copyrights",
                domProps: { innerHTML: _vm._s(_vm.copyrights) },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.legend
        ? _c("img", { ref: "legend", attrs: { id: "legend", src: _vm.legend } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }